<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.snow.css';

export default {
  name: "QuillViewer",
  components: { quillEditor },
  props: {
    value: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      content: this.value,
      editorOption: {
        placeholder: 'Écrivez votre contenu du mail ici',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
          ]
        }
      }
    };
  },
  watch: {
    content(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal) {
      if (newVal !== this.content) this.content = newVal;
    }
  }
};
</script>

<template>
  <quillEditor
    v-model="content"
    :options="editorOption"
  />
</template>


<style>

.ql-container.ql-snow {
  min-height: 200px;
}

.ql-size-small {
  font-size: 0.875rem;
}

.ql-size-large {
  font-size: 1.25rem;
}

.ql-size-huge {
  font-size: 1.5rem;
}

.ql-font-serif {
  font-family: 'Times New Roman', serif;
}

.ql-font-monospace {
  font-family: 'Courier New', monospace;
}

.ql-align {
  text-align: left;
}

.ql-align-left {
  text-align: left;
}

.ql-align-center {
  text-align: center;
}

.ql-align-right {
  text-align: right;
}

.ql-align-justify {
  text-align: justify;
}
</style>